import { Grid, Skeleton } from "@mui/material";

const arr = [1, 2, 3, 4, 5, 6];

export const SkeletonRecentBlog = () => {
  return (
    <>
      {arr.map((item, i) => {
        return (
          <Grid container spacing={2} alignItems={"center"} key={i}>
            <Grid item xs={12} sm={12} md={6} lg={3}>
              <Skeleton variant="rectangular" width="100%" height={60} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={9}>
              <Skeleton
                variant="rectangular"
                width="30%"
                height={10}
                sx={{ margin: "12px 0px" }}
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={10}
                sx={{ margin: "12px 0px" }}
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={10}
                sx={{ margin: "12px 0px" }}
              />
            </Grid>
          </Grid>
        );
      })}
    </>
  );
};

export default SkeletonRecentBlog;
